import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { globalCtx } from "../Context.js";
import { Mobiscroll_inputOptions, Mbs_DatePicker } from "../Feliz.Mobiscroll.js";
import { isBig } from "../Utils.js";

export function DateOnlyRangePicker(dateOnlyRangePickerInputProps) {
    const setValue = dateOnlyRangePickerInputProps.setValue;
    const value = dateOnlyRangePickerInputProps.value;
    const label = dateOnlyRangePickerInputProps.label;
    const ctx = reactApi.useContext(globalCtx);
    return Mbs_DatePicker([["controls", ["calendar"]], ["calendarSize", isBig(ctx.Responsive) ? 2 : 1], ["cssClass", isBig(ctx.Responsive) ? "mbs-force-horizontal-scroll" : ""], ["rangeStartLabel", "Start"], ["rangeEndLabel", "Slutt"], ["select", "range"], ["focusOnClose", false], ["value", value], ["onChange", (e) => {
        setValue(e.value);
    }], ["timeFormat", ""], ["dateFormat", "DD. MMM YYYY"], ["inputProps", Mobiscroll_inputOptions([["inputStyle", "outline"], ["label", label]])], ["touchUi", !isBig(ctx.Responsive)]]);
}

//# sourceMappingURL=DateOnlyRangePicker.js.map
